"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BigPhoto = function (_a) {
    var thumbnail = _a.thumbnail, withDeleteButton = _a.withDeleteButton, resetValue = _a.resetValue;
    var onClickDeleteButton = function (event) {
        event.stopPropagation();
        resetValue();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { src: thumbnail, alt: "[IMAGE]", className: "estimateForm-BigPhoto lazyload" }),
        withDeleteButton &&
            react_1.default.createElement("button", { onClick: onClickDeleteButton, className: "estimateForm-BigPhoto_DeleteButton" }, "\u00D7")));
};
exports.default = BigPhoto;
